
































































































































































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';

// --- Models ---
import { SubjectMarkPair } from '@/models/Subject.model';
import { UserInformation } from '@/models/User.model';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component({
  components: {
    BaseMaterialCard,
  },
})

export default class RegisterMorePage extends Vue {

  valid: boolean = false;
  newSubjectValid: boolean = false;
  clicked: boolean = false;

  userInfo: UserInformation = {
    id: 0,
    statusId: 0,
  };

  selectedSubject: string = '';
  selectedMark: string = '';

  subjects: SubjectMarkPair[] = [];
  subjectHeaders = [
    { 
      text: 'Subject', 
      value: 'subject',
    },
    { 
      text: 'Grade', 
      value: 'mark',
    },
    {
      sortable: false,
      text: '',
      value: 'action',
      align: 'end',
    },
  ];

  selectedAspectIds: number[] = [];

  rules = {
    required: (value: string) => !!value || '',
    itemRequired: (value: number) => value !== 0,
  };

  // #region Functions

    async beforeMount() {
      await AppService.getStatuses(false);
      await AppService.getMarks(false);
      await AppService.getSubjects(false);
      await AppService.getQualifications(false);
      await AppService.getCompanies(false);
      await AppService.getAspects(false);
    }

    addSubject() {
      if (this.subjects.findIndex((item: SubjectMarkPair) => (item.subject === this.selectedSubject)) !== -1) {
        AppService.errorHandler('That Subject is already selected. If you would like to change the mark please delete the subject.');
      } else {
        const selectedSubject: SubjectMarkPair = {
          subject: this.selectedSubject,
          mark: this.selectedMark,
        };

        this.subjects.unshift(selectedSubject);
        this.selectedSubject = '';
        this.selectedMark = '';

        if (this.$refs.subjectForm) {
          (this.$refs.subjectForm as any).resetValidation();
        }
      }
    }

    deleteSubject(selectedItem: SubjectMarkPair) {
      const index = this.subjects.findIndex((item: SubjectMarkPair) => (
        item.subject === selectedItem.subject // don't need to check mark matches as we stop them adding the same subject more than once in the add function
      ));
      this.subjects.splice(index, 1);
    }

    validateSubjects() {
      if (this.userInfo.statusId === 3 || this.userInfo.statusId === 4 || this.userInfo.statusId === 3) {
        if (this.subjects.length < 7) {
          return true;
        }
        return false;
      }
      return false;
    }

    validateAspects() {
      if (this.userInfo.statusId === 8) {
        if (this.selectedAspectIds.length < 3) {
          return true;
        }
        return false;
      }
      return false;
    }

    resetVariables() {
      // thse are the pages that show the subject selection table
      // if the user is going to these pages then we don't want to delete the subjects because they may previous input
      if (!(this.userInfo.statusId === 3 || this.userInfo.statusId === 4 || this.userInfo.statusId === 11)) {
        this.subjects = [];
      }

      // this can be done for each page combination but not sure if it's worth it or this is the correct way to do this
      this.userInfo = {
        id: 0,
        statusId: this.userInfo.statusId,
      };
      this.selectedAspectIds = [];
      

      if (this.$refs.form) {
        (this.$refs.form as any).resetValidation();
      }
      if (this.$refs.subjectForm) {
        (this.$refs.subjectForm as any).resetValidation();
      }
    }

    async saveUserInformation() {
      this.valid = true;
      this.clicked = true;

      try {
        const response = await AuthService.createUpdateStatusInformation({
          statusId: this.userInfo.statusId,
          currentJob: this.userInfo.currentJob,
          jobChangeWanted: this.userInfo.jobChangeWanted,
          appliedToProgram: this.userInfo.appliedToProgram,
          qualificationId: this.userInfo.qualificationId,
          preferredCompanyId: this.userInfo.preferredCompanyId,
          gapPlans: this.userInfo.gapPlans,
          plans: this.userInfo.plans,
          furtherStudy: this.userInfo.furtherStudy,
          registeredForTeriary: this.userInfo.registeredForTeriary,
          averageGradeId: this.userInfo.averageGradeId,          
          schoolName: this.userInfo.schoolName,   
          aspectIds: this.selectedAspectIds,
          selectedSubjects: this.subjects,
        });

        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
          this.$router.push({ name : 'Check Register Routing' });
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.clicked = false;
      }
    }

  // #endregion
}
